/* eslint-disable no-trailing-spaces */
/* eslint-disable indent */
/** 当路由表太长时，可以将其拆分为小模块 **/

import Layout from '@/layout'

const homeRouter = {
  path: '/home',
  component: Layout,
  redirect: 'noRedirect',
  name: 'home',
  meta: {
    title: '企业信息',
    icon: 'tree-table'
  },
  children: [
    // 赋码模块
    // {
    //   path: 'tagging',
    //   component: () => import('@/views/home/first'),
    //   name: 'tagging',
    //   redirect: 'noRedirect',
    //   meta: { title: '赋码管理', icon: 'star', roles: ['tagging'] },
    //   children: [
    //     {
    //       path: 'readycreate',
    //       component: () => import('@/views/home/tagging/readycreate'),
    //       name: 'readycreate',
    //       meta: { title: '预生码管理', roles: ['readycreate'] }
    //     },
    //     {
    //       path: 'records',
    //       component: () => import('@/views/home/tagging/records'),
    //       name: 'records',
    //       meta: { title: '生码记录表', roles: ['records'] }
    //     },
    //     {
    //       path: 'rulenews',
    //       component: () => import('@/views/home/tagging/rulenews'),
    //       name: 'rulenews',
    //       meta: { title: '生码查询表', roles: ['rulenews'] }
    //     },
    //     // {
    //     //   path: 'codeinputlist',
    //     //   component: () => import('@/views/home/tagging/codeinputlist'),
    //     //   name: 'codeinputlist',
    //     //   meta: { title: '码写入查询', roles: ['codeinputlist'] }
    //     // },

    //     {
    //       path: 'queryclose',
    //       component: () => import('@/views/home/tagging/queryclose'),
    //       name: 'queryclose',
    //       meta: { title: '关闭订单表', roles: ['queryclose'] }
    //     },
    //     {
    //       path: 'coderule',
    //       component: () => import('@/views/home/tagging/coderule/coderule'),
    //       name: 'coderule',
    //       meta: { title: '生码规则', roles: ['coderule'] }
    //     }

    //   ]
    // },
    // 基础信息板块
    {
      path: 'base',
      component: () => import('@/views/home/first'),
      name: 'base',
      redirect: 'noRedirect',
      meta: { title: '基础信息', icon: 'theme', roles: ['base'] },
      children: [
        {
          path: 'product',
          component: () => import('@/views/home/second'),
          name: 'product',
          redirect: 'noRedirect',
          meta: { title: '产品信息', roles: ['product'] },
          children: [
            {
              path: '/productlist',
              component: () => import('@/views/home/base/product/productlist'),
              name: 'productlist',
              meta: { title: '产品列表', roles: ['productlist'] }
            },
            {
              path: '/productpages',
              component: () => import('@/views/home/base/product/productpages'),
              name: 'productpages',
              hidden: true,
              meta: { title: '产品详情页' }
            },
            {
              path: '/productaddedit',
              component: () => import('@/views/home/base/product/productaddedit'),
              name: 'productaddedit',
              hidden: true,
              meta: { title: '产品新增编辑' }
            },
            {
              path: '/prodcutextend',
              component: () => import('@/views/home/base/product/prodcutextend/prodcutextend'),
              hidden: true,
              name: 'prodcutextend',
              meta: { title: '产品扩展信息' }
            },
            {
              path: '/productsort',
              component: () => import('@/views/home/base/product/productsort'),
              name: 'productsort',
              meta: { title: '品牌设置', roles: ['productsort'] }
            },
            {
              path: '/productunit',
              component: () => import('@/views/home/base/product/productunit/productunit'),
              name: 'productunit',
              meta: { title: '包装单位', roles: ['productunit'] }
            }
          ]
        },
        {
          path: '/store',
          component: () => import('@/views/home/base/store/store'),
          name: 'store',
          meta: { title: '仓库管理', roles: ['store'] }
        },
        {
          path: '/channelskey',
          component: () => import('@/views/home/base/channelskey/channelskey'),
          name: 'channelskey',
          meta: { title: '渠道Key管理', roles: ['channelskey']}
        },
        {
          path: '/dealer',
          component: () => import('@/views/home/base/dealer'),
          name: 'dealer',
          meta: { title: '经销商管理', roles: ['dealer'] }
        },
        {
          path: '/terminal',
          component: () => import('@/views/home/base/terminal'),
          name: 'terminal',
          meta: { title: '终端管理', roles: ['terminal'] }
        },
        {
          path: '/material',
          component: () => import('@/views/home/base/material/material'),
          name: 'material',
          meta: { title: '原料信息', roles: ['material'] }
        },
        {
          path: '/outsourcing',
          component: () => import('@/views/home/base/product/outsourcings/outsourcing'),
          name: 'outsourcing',
          meta: { title: '委外客户', roles: ['outsourcing'] }
        },
        {
          path: '/enterprise',
          component: () => import('@/views/home/base/enterprise'),
          name: 'enterprise',
          meta: { title: '维护企业', roles: ['enterprise'] }
        }
      ]
    },
    // 组织结构板块
    {
      path: 'organ',
      component: () => import('@/views/home/first'),
      name: 'organ',
      redirect: 'noRedirect',
      meta: { title: '组织机构', icon: 'example', roles: ['organ'] },
      children: [
        {
          path: '/tree',
          component: () => import('@/views/home/organ/tree'),
          name: 'tree',
          meta: { title: '组织机构', roles: ['tree'] }
        },
        { // 新增页面
          path: 'departmentjob',
          component: () => import('@/views/home/organ/role/departmentjob'),
          name: 'departmentjob',
          meta: { title: '部门职位管理', roles: ['departmentjob'] }
        },
        {
          path: '/staff',
          component: () => import('@/views/home/second'),
          name: 'staff',
          redirect: 'noRedirect',
          meta: { title: '人员管理', roles: ['staff'] },
          children: [
            {
              path: '/stafflist',
              component: () => import('@/views/home/organ/staff/stafflist'),
              name: 'stafflist',
              meta: { title: '账号管理', roles: ['stafflist'] }
            }
            // {
            //   path: '/deliveryid',
            //   component: () => import('@/views/home/organ/staff/deliveryid'),
            //   name: 'deliveryid',
            //   meta: { title: '送达方账号管理', roles: ['deliveryid'] }
            // }
          ]
        },
        {
          path: '/role',
          component: () => import('@/views/home/second'),
          name: 'role',
          redirect: 'noRedirect',
          meta: { title: '权限管理', roles: ['role'] },
          children: [
            {
              path: 'rolemanage',
              component: () => import('@/views/home/organ/role/rolemanage'),
              name: 'rolemanage',
              meta: { title: '权限管理', roles: ['rolemanage'] }
            }
          ]
        }
      ]
    }
  ]
}

export default homeRouter
